import React, {useEffect, useState} from 'react';
import {Card, Button, Tag} from 'antd';
import "./HomeTour.css";
import {ClockCircleOutlined} from '@ant-design/icons';
import {getNotificationSettings} from "../settings/notifications/apis/apis";
import {acceptOrRejectRequest, getHomeTourRequests} from "../requestHomeTour/apis/apis";
import {createConversation} from "../conversation/apis/apis";
import {useNavigate} from "react-router-dom";

const HomeTour = () => {

    const [requests, setRequests] = useState([]);
    const [refresh , setRefresh] = useState(false);

    const fetchTourRequests = async () => {
        try {
            const response = await getHomeTourRequests()
            const apiData = response?.data?.data;

            if (apiData) {
                setRequests(apiData);
            }
        } catch (error) {
            console.error("Error fetching notification settings:", error);
        }
    };


    useEffect(() => {
        fetchTourRequests()
    }, [refresh]);


    const navigate = useNavigate()

    const userId = localStorage.getItem("userId");

    return <div className={"homeTourContainer"}>
        <h3>New Requests</h3>

        {
            requests.length > 0 ? requests.map((item) => (
                <Card style={{
                    marginTop: 20
                }} type="inner" title={`${item?.property?.title || ''}`} extra={
                    <div className={"buttons"}>
                        <Button
                            variant={"solid"}
                        onClick={()=>{
                            try {
                                navigate(`/details/${item?.propertyId}`)
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }}>
                            View Property
                        </Button>

                        <Button
                            variant={"solid"}
                            color={"primary"}
                            onClick={async () => {
                                try {
                                    await createConversation(item?.user?.id)
                                    navigate("/conversation")
                                }
                                catch (e) {
                                    console.error(e);
                                }
                            }}>
                            Contact
                        </Button>

                        {
                            parseInt(userId) !== item.userId && item.status === 0 ?
                                <>
                                    <Button
                                        variant={"solid"}
                                        color={"danger"}
                                        onClick={async () => {
                                            try {
                                                await acceptOrRejectRequest(item?.id, {
                                                    status: false
                                                })
                                                setRefresh(!refresh)
                                            }catch (e) {
                                                console.error(e);
                                            }
                                        }}>
                                        Reject
                                    </Button>

                                    <Button
                                        variant="solid"
                                        color={"primary"}
                                        onClick={async () => {
                                            try{
                                                await acceptOrRejectRequest(item?.id, {
                                                    status: true
                                                })

                                                setRefresh(!refresh)
                                            }
                                            catch (e) {
                                                console.error(e);
                                            }
                                        }}>
                                        Accept</Button>
                                </>
                                : null
                        }

                    </div>
                }>
                    {item?.user?.name || item?.user?.email}
                    <br/>
                    <div className={"dntContainer"}>
                        <Tag className={"dntContainerTag"} color="#2db7f5"
                             icon={<ClockCircleOutlined/>}>Date: {new Date(item.tourDate).toDateString()}</Tag>
                        <Tag className={"dntContainerTag"} color="#2db7f5" icon={<ClockCircleOutlined/>}>Time
                            : {item.tourTime}</Tag>
                        <Tag className={"dntContainerTag"} color={item.status === -1 ? 'red' : item.status === 0 ? 'yellow' : 'green'} >Status
                            : {item.status === -1 ? 'Rejected' : item.status === 0 ? 'Pending' : 'Accepted'}</Tag>
                    </div>
                </Card>
            ))
                : <p style={{
                    textAlign: "center",
                marginTop: '5rem',
                marginBottom:'5rem'
                }}>No New Request At the moment</p>
        }

    </div>
}

export default HomeTour